import { fetchEdoTypes } from '../../../services/api/common';
import { chooseEdo } from '../../../services/api/profile';

export const edoTypes = {
    namespaced: true,
    state: {
        types: {},
    },
    mutations: {
        save(state, data) {
            state.types = data;
        }
    },
    actions: {
        fetchEdoTypes({ commit, dispatch }) {
            return fetchEdoTypes()
                .then((res) => {
                    commit('save', res.data);

                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    throw res;
                });
        },
        chooseEdo({ commit }, edoId) {
            return chooseEdo(edoId);
        }
    },
    getters: {
        isFetched({ types }) {
            return !!Object.keys(types).length;
        },
    }
}


// WEBPACK FOOTER //
// ./src/modules/home/contractElectronic/store.js